import React, { useState } from 'react';
import { MapPinIcon, ChevronDownIcon } from 'lucide-react';
export const ServiceAreas = () => {
  const [expandedStates, setExpandedStates] = useState({
    Michigan: false,
    Ohio: false,
    Illinois: false,
    Indiana: false
  });
  const toggleState = state => {
    setExpandedStates({
      ...expandedStates,
      [state]: !expandedStates[state]
    });
  };
  const serviceAreas = [{
    state: 'Michigan',
    cities: ['Detroit', 'Grand Rapids', 'Warren', 'Ann Arbor', 'Dearborn', 'Troy', 'Northville', 'Lansing', 'Flint', 'Kalamazoo']
  }, {
    state: 'Ohio',
    cities: ['Columbus', 'Cleveland', 'Cincinnati', 'Toledo', 'Akron', 'Dayton', 'Canton', 'Youngstown', 'Parma', 'Lorain']
  }, {
    state: 'Illinois',
    cities: ['Chicago', 'Aurora', 'Naperville', 'Joliet', 'Rockford', 'Springfield', 'Peoria', 'Elgin', 'Waukegan', 'Cicero']
  }, {
    state: 'Indiana',
    cities: ['Indianapolis', 'Fort Wayne', 'Evansville', 'South Bend', 'Carmel', 'Fishers', 'Bloomington', 'Hammond', 'Gary', 'Lafayette']
  }];
  return <section className="relative py-16 overflow-hidden" data-id="element-270">
      {/* Background Image with Parallax */}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/dURRENHQLg8QML8EPd2wPB/ChatGPT_Image_Oct_24%2C_2025%2C_02_45_37_PM.png')",
      backgroundAttachment: 'fixed'
    }} data-id="element-271"></div>
      {/* Light Blue Overlay - reduced opacity */}
      <div className="absolute inset-0 bg-blue-100 opacity-30" data-id="element-272"></div>
      {/* Content */}
      <div className="relative container mx-auto px-4" data-id="element-273">
        <div className="text-center mb-12" data-id="element-274">
          <h2 className="font-serif text-3xl font-bold text-kgi-blue-900 mb-3" data-id="element-275">
            Service Areas
          </h2>
          <p className="text-gray-700 max-w-2xl mx-auto" data-id="element-276">
            Licensed to operate in Michigan, Illinois, Indiana, and Ohio, with
            nationwide consulting partners
          </p>
        </div>
        <div className="max-w-5xl mx-auto" data-id="element-277">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-278">
            {serviceAreas.map((area, index) => <div key={index} className="bg-white rounded-lg shadow-sm p-6" data-id="element-279">
                <button onClick={() => toggleState(area.state)} className="w-full text-left focus:outline-none group" data-id="element-280">
                  <div className="flex items-center justify-between" data-id="element-281">
                    <div className="flex items-center gap-2" data-id="element-282">
                      <MapPinIcon className="h-5 w-5 text-kgi-red" data-id="element-283" />
                      <h3 className="font-serif text-xl font-bold text-kgi-blue-900 group-hover:text-kgi-red transition-colors" data-id="element-284">
                        {area.state}
                      </h3>
                    </div>
                    <ChevronDownIcon className={`h-5 w-5 text-gray-400 transition-transform ${expandedStates[area.state] ? 'rotate-180' : ''}`} data-id="element-285" />
                  </div>
                </button>
                {expandedStates[area.state] && <ul className="mt-4 pt-4 border-t border-gray-200 space-y-2" data-id="element-286">
                    {area.cities.map((city, cityIndex) => <li key={cityIndex} className="text-sm text-gray-700" data-id="element-287">
                        • {city}
                      </li>)}
                  </ul>}
              </div>)}
          </div>
          <div className="text-center bg-white rounded-lg shadow-sm p-8" data-id="element-288">
            <p className="text-gray-700 mb-4" data-id="element-289">
              Don't see your location? We serve all areas within our licensed
              states and coordinate with partners nationwide.
            </p>
            <a href="#contact" className="inline-flex items-center bg-kgi-red hover:bg-kgi-red-600 text-white font-bold py-3 px-6 rounded transition duration-300" data-id="element-290">
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </section>;
};